import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class ShelterSelectorController extends Controller {
  static targets = ['selector']

  connect () {
    if (this.hasSelectorTarget) {
      this.initializeTomSelect(this.selectorTarget)
    }
  }

  disconnect () {
    if (this.tomSelect) {
      this.tomSelect.destroy()
      this.tomSelect = null
    }
  }

  initializeTomSelect (selectorElement) {
    this.tomSelect = new TomSelect(selectorElement, {
      create: false,
      sortField: {
        field: 'text',
        direction: 'asc'
      },
      searchField: ['text'],
      placeholder: 'Select a shelter',
      onChange: (value) => {
        this.changeShelter(value)
      },
      onInitialize: () => {
        this.applyWidth()
      }
    })

    setTimeout(() => this.applyWidth(), 10)
  }

  applyWidth () {
    const tsWrapper = this.element.querySelector('.ts-wrapper')
    const tsControl = this.element.querySelector('.ts-control')

    if (tsWrapper) {
      tsWrapper.style.width = '100%'
      tsWrapper.style.minWidth = '250px'
    }

    if (tsControl) {
      tsControl.style.width = '100%'
      tsControl.style.minWidth = '250px'
    }
  }

  changeShelter (shelterId) {
    const form = this.element.querySelector('form')
    if (form && shelterId) {
      form.submit()
    }
  }
}
